import type { IconSvgObject } from './types';

const ArrowDownLeft02Icon: IconSvgObject = [
  ["path", { d: "M7 11L6 18L13 17L7 11Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 14L17.9975 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDownLeft02Icon;
